<template>
      <div class="vsebina ">

    <div class="glava_vsebine adapt v-adapt">

      <div class="cols">
      <div class="col left grid-col-6">
        <h1>Predelovalec</h1>
      </div>
      
      
      
      <div class="col right">
      </div>
      
      </div>
    </div>
    
    <div class="telo_vsebine adapt v-adapt">
<div v-if="!pridelovalecid">
    NI PODATKOV
</div>
<div v-else>
<div>
        <div :style="{ display: 'inline-block' }">
            Sezona
            <br />
            <dropdownlist
                :data-items="sezonePisanje"
                :text-field="'sezona'"
                @change="sezonaChange"
                :value="dataSezona"
            />
            <pridelovalec :pridelovalec="pridelovalec"  shema="EKO PRE" :sezona="dataSezona.sezona">
          </pridelovalec>
            
          </div>
        </div>
 <div class="uporabnik-spacer" style="margin-top:2rem"></div>
<div class="">
<form @submit.prevent="handleSubmit" class="k-form">
            <div class="form-group">
                  <div class="km-widget km-buttongroup k-widget k-button-group">
                <button class="k-button k-primary" :disabled="pridelovalec.pisanje==0" @click="saveData" >Shrani</button>
                <button class="k-button k-primary" @click="nazaj" >Nazaj</button>
               </div>
             </div>


     <div class="display-flex pt-1">

    <div>
            <fieldset class="left-border-for-children">
                 <div class="form-fieldset-header">
            <h2 >Podatki o kmetiji</h2>
        </div>

            </label>
              <label for="jeaktivna" class="k-form-field k-checkbox-field">
                <span>Je v kontroli (aktivna)</span>
            <input type="checkbox" :disabled="pridelovalec.pisanje==0" v-model="jeaktivna"  name="jeaktivna" id="jeaktivna" class="k-checkbox" />
        </label>

             <label for="kntst" class="k-form-field">
                <span>Kontrolna številka</span>
                
                <input type="text" :disabled="pridelovalec.pisanje==0" v-model="kontrolnastevilka" placeholder="Kontrolna številka" name="kntst" id="kntst" class="k-textbox" />
                 
            </label>
            <!--
              <label for="vezanareja" class="k-form-field k-checkbox-field">
                <span>Kmetija ima vezano rejo živali</span>
            <input type="checkbox" :disabled="pridelovalec.pisanje==0" v-model="imavezanezivali"  name="vezanareja" id="vezanareja" class="k-checkbox" />
        </label>
        <label for="travojedezivali" class="k-form-field k-checkbox-field">
                <span>Kmetija ima travojede živali</span>
            <input type="checkbox" :disabled="pridelovalec.pisanje==0" v-model="imatravojedezivali"  name="travojedezivali" id="travojedezivali" class="k-checkbox" />
        </label>
    -->
<div class="display-flex">
            <label for="status" class="k-form-field flex-grow-1">
                <span>Status</span>
                 <dropdownlist
                @change="spremeniStatus"
                 name="status"
                :data-items="status"
                :text-field="'naziv'"
                :value="izbranStatus"
                :disabled="pridelovalec.pisanje==0"
                
            />
            </label>

            <label for="statusDolocen" class="k-form-field">
                <span>Datum določitve statusa</span>
               <kendo-datepicker :disabled="pridelovalec.pisanje==0" id="statusDolocen"
                       :value="statusDolocen"
                       @change="zamenjajDatum"
                      :format="'dd.MM.yyyy'"></kendo-datepicker>
            </label>
        </div>
         <div class="display-flex">
            <label for="vrsta" class="k-form-field flex-grow-1">
                <span>Vrsta predelovalca</span>
                 <dropdownlist
              
                 name="vrsta"
                :data-items="vrstapredelovalca"
                :text-field="'naziv'"
                v-model="izbranaVrsta"
                :disabled="pridelovalec.pisanje==0"
                
            />
            </label>

         
        </div>
            <div class="k-form-field">
                <span>Dejavnosti predelovalca (vse)</span>
            <kendo-multiselect :value="vrstapridelovalcavse"
                        :data-items="vrsta"
                        :text-field="'naziv'"
                        :data-item-key="'id'"
                        :placeholder="'Izberi vrsto'"
                        id="vrstapridelovalca"
                        @change="spremeniVrstoVse"
                        :messages="multiselectmessages"
                       :disabled="pridelovalec.pisanje==0"
                         :filterable="true"
                        :auto-width="true"
                        >
            </kendo-multiselect>
        </div>
        <div class="k-form-field">
                <span>Dejavnosti predelovalca (certificirane)</span>
            <kendo-multiselect :value="vrstapridelovalca"
                        :data-items="vrsta"
                        :text-field="'naziv'"
                        :data-item-key="'id'"
                        :placeholder="'Izberi vrsto'"
                        id="vrstapridelovalca"
                        @change="spremeniVrsto"
                        :messages="multiselectmessages"
                       :disabled="pridelovalec.pisanje==0"
                         :filterable="true"
                        :auto-width="true"
                        >
            </kendo-multiselect>
        </div>
      <div class="k-form-field">
                <span>Dejavnosti predelovalca (kot podizvajalec)</span>
            <kendo-multiselect :value="dejavnostizadruge"
                        :data-items="vrsta"
                        :text-field="'naziv'"
                        :data-item-key="'id'"
                        :placeholder="'Izberi vrsto'"
                        id="dejavnostizadruge"
                        @change="spremeniDejavnostiZaDruge"
                        :messages="multiselectmessages"
                       :disabled="pridelovalec.pisanje==0"
                         :filterable="true"
                        :auto-width="true"
                        >
            </kendo-multiselect>
        </div>
            </fieldset>
             </div>
             
               
          


           
                <div>
                    <fieldset class="left-border-for-children">
                         <div class="form-fieldset-header">
                            <h2 >Certificirane kategorije</h2>
                        </div>
                         <div class="kat_chk_list">
                            <template v-for="kategorija in kategorije">
                                <div :class="{'izbranakategorija':izbranekategorije.find(i=>(i.id?i.id:i)==kategorija.id)}">
                                <input class="form-check-input" v-model="kategorijepridelovalca"  type="checkbox" :value="kategorija.id" :id="'kat_chk_'+kategorija.id">
                                <label class="form-check-label" :for="'kat_chk_'+kategorija.id" >
                                ({{kategorija.id}}) {{kategorija.naziv}}
                                </label>
                                <dropdownlist style="{ width: '60px';display: 'inline-block';}" :data-items='vrstapridelave' default-value="EK-P"
                                v-model="statuskategorije[kategorija.id]"  @change="handlestatuskategorijechange(kategorija.id,$event)" >
                                </dropdownlist>
                                </div>
                                
                            
                            </template>
                    
        </div>


                    </fieldset>
           
                 </div>
             </div>
        </form>
    </div>
    </div>
    </div>
    </div>

</template>

<script>
import Vue from 'vue';
import { mapState, mapActions,mapMutations } from 'vuex'
import { DatePicker } from '@progress/kendo-vue-dateinputs';
import { MultiSelect, DropDownList } from '@progress/kendo-vue-dropdowns';
import { provideIntlService } from '@progress/kendo-vue-intl';
import { Checkbox } from "@progress/kendo-vue-inputs";
import PridelovalecKratko from './support/PridelovalecKratko';
export default {
     components: {
    'kendo-datepicker': DatePicker,
    'kendo-multiselect': MultiSelect,
    'dropdownlist': DropDownList,
    'pridelovalec':PridelovalecKratko,
    'kendo-checkbox': Checkbox
  },
    props:['sezona','pridelovalecid'],
    data () {
        return {
                  dataSezona:this.sezona,
                   sezone:[],

            kmgmid:"",posta:"",postnastevilka:"",naslov:"",ime:"",priimek:"",telefon:"",email:"",opomba:"",postnastevilkakontakt:"",postakontakt:"",postnastevilkanosilec:"",postnanosilec:"",naslovkontakt:"",priimekkontakt:"",postanosilca:"",postnastevilkanosilca:"",emso:"",imekontakt:"",kntst:"",
            emailnosilca:"",telefonnosilca:"",
           
          
            password: '',
            submitted: false,
            multiselectmessages: 
            {
            "singleTag": "izbrani elementi",
            "clear": "Počisti",
            "deleteTag": "Izbriši",
            "noData": "Ni podatkov"
            },
            vrstapridelave:["EK+K","EK-P","P"],
            
            vrsta:[],
            status:[],
            statuskategorije:[],
            kategorije:[]
        }
    },
    computed: {
        imavezanezivali:
        {
           get() {

            return this.pridelovalec.imavezanezivali>0?true:false;
          },
          set(value) {
            this.updateprop({sezona:this.dataSezona.sezona,shema:"EKO PRE",property:"imavezanezivali",value:value?1:0});

          }
        },
         vrstapridelovalca:
        {
           get() {

            let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema=="EKO PRE");

            if (pridelava)
                return pridelava.dejavnosti;
            else
                return [];

          }
        },
         izbranekategorije:
        {
           get() {

            let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema=="EKO PRE");

            if (pridelava)
                return pridelava.izbranekategorije;
            else
                return [];

          },
         
        },
        
        kategorijepridelovalca:
        {
           get() {

            let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema=="EKO PRE");

            if (pridelava)
                return pridelava.kategorije.map(i=>(i.id?i.id:i));
            else
                return [];

          },
          set(value){

            //let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema=="EKO PRE");
            //pridelava.kontrolnaStevilka=value;
            console.log("UPDATE CHKBOX");
            console.log(value);
            this.updateshemaprop({sezona:this.dataSezona.sezona,shema:"EKO PRE",property:"kategorije",value:value.map(i=>{return {id:i,status:this.statuskategorije  [i]}})});
          }
        },
        vrstapridelovalcavse:
        {
           get() {

            let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema=="EKO PRE");

            if (pridelava)
                return pridelava.vsedejavnosti;
            else
                return [];

          }
        },
        dejavnostizadruge:
        {
           get() {

            let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema=="EKO PRE");

            if (pridelava)
                return pridelava.dejavnostizadruge;
            else
                return [];

          }
        },
         kontrolnastevilka:
        {
           get() {

            let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema=="EKO PRE");

            if (pridelava)
                return pridelava.kontrolnaStevilka;
            else
                return null;

          },
          set(value){

            //let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema=="EKO PRE");
            //pridelava.kontrolnaStevilka=value;
            this.updateshemaprop({sezona:this.dataSezona.sezona,shema:"EKO PRE",property:"kontrolnaStevilka",value:value});
          }

        },
         jeaktivna:
        {
           get() {
            let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema=="EKO PRE");

            if (pridelava)
                return pridelava.jeaktivna
            
            //return this.pridelovalec.sheme.find(s=>s.sezona==this.sezona&&s.shema=="EKO PRE").jeaktivna>0?true:false;
          },
          set(value) {
            this.updateshemaprop({sezona:this.dataSezona.sezona,shema:"EKO PRE",property:"jeaktivna",value:value?1:0});

          }
        },
        imatravojedezivali:
        {
           get() {

            return this.pridelovalec.imatravojedezivali>0?true:false;
          },
          set(value) {

           this.updateprop({property:"imatravojedezivali",value:value?1:0});

          }
        },
        izbranStatus:
        {
           get() {

             let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema=="EKO PRE");

           if (pridelava)
                return this.status.find(s=>s.naziv==pridelava.status);
           else
                return null;
            

          },
          set(value) {
           this.updateshemaprop({sezona:this.dataSezona.sezona,shema:"EKO PRE",property:"status",value:value.naziv});

          }
        },
        izbranaVrsta:
        {
           get() {

             let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema=="EKO PRE");

           if (pridelava)
                return this.vrstapredelovalca?.find(s=>s.naziv==pridelava.vrstapredelovalca)??this.vrstapredelovalca?.find(s=>s.id==0);
           else
                return this.vrstapredelovalca?.find(s=>s.id==0);
            

          },
          set(value) {
           this.updateshemaprop({sezona:this.dataSezona.sezona,shema:"EKO PRE",property:"vrstapredelovalca",value:value.naziv});

          }
        },
        statusDolocen:
        {
           get() {
          let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema=="EKO PRE");

            if (pridelava&&pridelava.datumDolocitve)
                return provideIntlService(this).parseDate(pridelava.datumDolocitve);
            else
                this.updateshemaprop({sezona:this.dataSezona.sezona,shema:"EKO PRE",property:"datumDolocitve",value:(new Date()).toISOString()});
                return new Date();
             
          },
          set(value) {
       
          
             this.updateshemaprop({sezona:this.dataSezona.sezona,shema:"EKO PRE",property:"datumDolocitve",value:value.toISOString()});
          }
        },
        ...mapState('users', ['sezonePisanje','sheme']),
        ...mapState('pridelava', ['pridelovalec']),
        ...mapState('sifrant', ['sifrant','dataSezone'])
        
    },
    created () {
      if(!this.sezona)
        this.dataSezona={sezona:2022};
      else
      this.dataSezona={sezona:this.sezona};

       this.naloziPodatke();
     
    },
    methods: {
        
        ...mapActions({naloziSifrant: 'sifrant/load'}),
        ...mapActions('pridelava',['loadOne','save','loadIdPoSezoni']),
         ...mapMutations('pridelava',['updateprop','updateshemaprop']),
         
        saveData(e){
          this.save( this.dataSezona);
        },
          handleSubmit(e){

          e.preventDefault();
        },
         cancel(e){
              this.$router.go(-1)
        },
        handlestatuskategorijechange (id,event)  {
             
            //this.kategorijepridelovalca=this.kategorijepridelovalca.map(i=>{return {id:i,status:event.target.value [i]}});
            console.log("handlestatuskategorijechange");
            console.log(id);
            console.log(event.value);
            let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema=="EKO PRE");
            var k=pridelava.kategorije.map(i=>{
                if (i.id==id)
                    return {...i,status:event.value};
                return i;   
            });
            console.log(k);
            this.updateshemaprop({sezona:this.dataSezona.sezona,shema:"EKO PRE",property:"kategorije",value:k});


        },
        spremeniVrstoVse (event)  {
             
             this.updateshemaprop({sezona:this.dataSezona.sezona,shema:"EKO PRE",property:"vsedejavnosti",value:[...event.target.value]});
            
        },
         spremeniVrsto (event)  {
             
             this.updateshemaprop({sezona:this.dataSezona.sezona,shema:"EKO PRE",property:"dejavnosti",value:[...event.target.value]});
            
        },
        spremeniDejavnostiZaDruge (event)  {
             
             this.updateshemaprop({sezona:this.dataSezona.sezona,shema:"EKO PRE",property:"dejavnostizadruge",value:[...event.target.value]});
            
        },
         spremeniStatus (event)  {
              this.izbranStatus=event.target.value;
            
        },
        zamenjajDatum(e){
            console.log(e);
            this.statusDolocen=e.value;
        },
       
        naloziPodatke (){
            // this.dataSezona={sezona:this.sezona};
       // this.dataSezone
//         this.sifrant["statuspridelovalca"]
  //       this.sifrant["vrstapridelovalca"]
         var thisComp=this;
        this.naloziSifrant({sezona:this.dataSezona.sezona,sifrant:"vrstapridelovalca"}).then(()=>{
            thisComp.vrsta=thisComp.sifrant["vrstapridelovalca"];
        });
        this.naloziSifrant({sezona:this.dataSezona.sezona,sifrant:"statuspredelovalca"}).then(()=>{
            thisComp.status=thisComp.sifrant["statuspredelovalca"];
        });

         this.naloziSifrant({sezona:this.dataSezona.sezona,sifrant:"kategorije"}).then(()=>{
            thisComp.kategorije=thisComp.sifrant["kategorije"];
        });
           this.naloziSifrant({sezona:this.dataSezona.sezona,sifrant:"vrstapredelovalca"}).then(()=>{
            thisComp.vrstapredelovalca=thisComp.sifrant["vrstapredelovalca"];
        });
        this.loadOne({sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalecid}).then(p=>{


            let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema=="EKO PRE");
            if (pridelava) {
            pridelava.kategorije.forEach(e=>{
                Vue.set(this.statuskategorije,e.id,e.status);
            });
            }
            console.log("nastavim status kategorije");
            console.log(this.statuskategorije);

        });
      
        },
         sezonaChange(event) {
         

              const sezona = event.value;
            this.dataSezona=sezona;
            //this.loadIdPoSezoni({sezona:sezona.sezona,pridelovalecid:this.pridelovalecid}).then(pridelovalec=>{
//              this.pridelovalecid=pridelovalec.id;
             this.$router.push({ name: 'pridelovalec', params: {sezona:sezona.sezona,pridelovalecid:pridelovalec.id} });
  //           this.naloziPodatke();
    //          });


          //  this.naloziPodatke();



        },
    }
};
</script>

<style scoped>

.izbranakategorija{
   background-color: var(--accent);
   
}
.k-checkbox-field {
    display: flex !important;
    align-items: center;
}
.kat_chk_list{
display:flex;
flex-direction:column;

}

form {
display:flex;
flex-direction:column;
}

.k-checkbox-field input[type="checkbox"]{
    margin-left: 0.5rem;

}
</style>